import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

/** DOM ids for `CarriersCompanyPage` hash scrolling (`/profile/.../company#brokers`). */
export const CARRIERS_COMPANY_PAGE_HASH = {
	brokers: "brokers",
};

export default build([
	{
		path: "/profile/company",
		component: lazy(() => import("./CarriersCompanyPage")),
	},
	{
		path: "/profile/carriers/:carrierId/company",
		component: lazy(() => import("./CarriersCompanyPage")),
	},
]);
